import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Characterization",
  layout: {
    type: "customCase040103",
    options: {
      views: {
        parameters: {
          wooferImageUrl: `${config.ASSETS_URL}/04/case-01/slide03-parameters01.svg`,
          tweeterImageUrl: `${config.ASSETS_URL}/04/case-01/slide03-parameters02.svg`,
        },
        impedance: {
          gallery: [
            {
              imageUrl: `${config.ASSETS_URL}/04/case-01/slide03-impedance01.svg`,
              description: "1. Woofer",
            },
            {
              imageUrl: `${config.ASSETS_URL}/04/case-01/slide03-impedance02.svg`,
              description: "2. Tweeter",
            },
          ],
        },
        bass: {
          image: `${config.ASSETS_URL}/04/case-01/slide03-bass.svg`,
        },
        port: {
          description: {
            eqImageUrl: `${config.ASSETS_URL}/04/case-01/slide03-port-eq.svg`,
          },
          task: {
            correctAnswer: "14.0",
          },
        },
        electrical: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide03-electrical.svg`,
        },
        frequency: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide03-frequency.svg`,
        },
      },
    },
  },
};

export default principle;
